
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eTFt9", function(module, exports) {
/* ShortcutsSection.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/jsx-boolean-value */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $g5gZt = parcelRequire("g5gZt");


var $6lLr9 = parcelRequire("6lLr9");


var $4iPjq = parcelRequire("4iPjq");


var $7pxpu = parcelRequire("7pxpu");


var $ggbZE = parcelRequire("ggbZE");


var $1qfLF = parcelRequire("1qfLF");


var $1CdLs = parcelRequire("1CdLs");

var $YQCfa = parcelRequire("YQCfa");

var $8INvs = parcelRequire("8INvs");


var $8fW0f = parcelRequire("8fW0f");


var $jmjWc = parcelRequire("jmjWc");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $3W9OD = parcelRequire("3W9OD");


var $7aRa9 = parcelRequire("7aRa9");


var $ks2xb = parcelRequire("ks2xb");


var $j3kZx = parcelRequire("j3kZx");


var $6M71K = parcelRequire("6M71K");

class $afc4f249091844f7$export$e70d8e402993d6df {
    push({ undo: undo, lastDeletedItem: lastDeletedItem }) {
        this.stack.push({
            undo: undo,
            lastDeletedItem: lastDeletedItem
        });
        this.stack = this.stack.slice(-1 * this.size);
    }
    constructor(){
        this.size = 1;
        this.stack = [];
        this.pop = ()=>this.stack.pop();
        this.peek = ()=>this.stack.slice(-1)[0];
        this.reset = ()=>{
            this.stack = [];
        };
    }
}



var $h4oCC = parcelRequire("h4oCC");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $3tMMZ = parcelRequire("3tMMZ");


var $9HB34 = parcelRequire("9HB34");

const $5c93c5d8d8ceb234$var$relayEnvironment = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));

const $5c93c5d8d8ceb234$var$ShortcutsDragContainer = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RRkgO",
    name: "ShortcutsDragContainer",
    loader: async ()=>(await (parcelRequire("5ymWN"))).ShortcutsDragContainer
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c93c5d8d8ceb234$var$LinksSectionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _7hxb1r31 _9m7f1r31 _qfs11r31 _15zvglyw _w7swglyw _s41oglyw _1xvinqa1 _15a9nqa1 _1k6pnqa1 _p03c12zz _oavv12zz _1cay12zz",
            __cmplp.className
        ])
    });
});
const $5c93c5d8d8ceb234$var$i18n = (0, $cgtv4.defineMessages)({
    spaceShortcutsHeader: {
        id: "space-shortcuts.shortcuts.header",
        defaultMessage: "Shortcuts"
    },
    spaceShortcutsAddLinkTooltip: {
        id: "space-shortcuts.shortcuts.add.tooltip",
        defaultMessage: "Add shortcut"
    },
    shortcutsTooltip: {
        id: "space-shortcuts.side-nav-collapsible-header.tooltip",
        defaultMessage: "Quick links to Confluence or web content"
    },
    noShortcutsMessage: {
        id: "space-shortcuts.no-shortcuts.message",
        defaultMessage: "No shortcuts in this space"
    }
});
const $5c93c5d8d8ceb234$var$ShortcutsSectionComponent = /*#__PURE__*/ (0, $42omo.memo)(({ flags: flags, isSpaceAdmin: isSpaceAdmin, links: links, spaceId: spaceId, spaceKey: spaceKey })=>{
    const shortcutsHistoryRef = (0, $42omo.useRef)(new (0, $afc4f249091844f7$export$e70d8e402993d6df)());
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const handlePopupClose = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
    }, [
        setIsPopupOpen
    ]);
    const { addShortcut: addShortcut, undoAddShortcut: undoAddShortcut } = (0, $h4oCC.useAddShortcut)(links, flags, shortcutsHistoryRef);
    const { linkCreated: linkCreated } = (0, $7pxpu.useSmartLinkLifecycleAnalytics)(); // collapsed by default if there are no shortcuts
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'shortcuts',
        collapsedByDefault: links.length === 0
    });
    const onSubmit = (0, $42omo.useCallback)((payload, analytic)=>{
        const { url: url, displayText: title } = payload; // hides previous success flag so that only one is on the screen at a time
        const lastMovement = shortcutsHistoryRef.current.peek();
        if (lastMovement) flags.hideFlag(lastMovement.flagId);
        const item = {
            url: url,
            title: title
        };
        addShortcut(item); // needed for undo functionality
        shortcutsHistoryRef.current.push({
            undo: ()=>undoAddShortcut(item),
            lastDeletedItem: item
        });
        handlePopupClose();
        linkCreated(payload, analytic);
    }, [
        handlePopupClose,
        addShortcut,
        undoAddShortcut,
        flags,
        linkCreated
    ]);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const plugins = (0, $42omo.useMemo)(()=>[
            new (0, $8fW0f.default)({
                searchProvider: searchProvider,
                activityClientEndpoint: `${window.location.origin}/gateway/api/graphql`
            })
        ], [
        searchProvider
    ]);
    const renderAddShortcutButton = (0, $42omo.useCallback)(()=>// TODO: Add `shouldRenderToParent` to component to improve accessibility. See
        // https://a11y.atlassian.net/browse/JCATS-788
        // https://hello.atlassian.net/wiki/spaces/DST/pages/5402216605/shouldRenderToParent+prop+usages+in+cc-disco+packages
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            autoFocus: false,
            isOpen: isPopupOpen,
            onClose: ()=>handlePopupClose(),
            content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
                    plugins: plugins,
                    onSubmit: onSubmit,
                    onCancel: handlePopupClose,
                    onContentResize: update
                }),
            placement: "bottom-start",
            trigger: (triggerProps)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5c93c5d8d8ceb234$var$i18n.spaceShortcutsAddLinkTooltip),
                    position: "top",
                    hideTooltipOnMouseDown: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                            ...iconProps,
                            size: "small"
                        }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5c93c5d8d8ceb234$var$i18n.spaceShortcutsAddLinkTooltip),
                    onClick: ()=>setIsPopupOpen((v)=>!v),
                    spacing: "compact",
                    appearance: "subtle",
                    ...triggerProps
                }));
            }
        }), [
        isPopupOpen,
        handlePopupClose,
        plugins,
        onSubmit
    ]); // Show nothing if the user is not a space admin and there are no shortcuts
    if (!isSpaceAdmin && links.length == 0) return null;
    const menuContent = links.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c93c5d8d8ceb234$var$LinksSectionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c93c5d8d8ceb234$var$ShortcutsDragContainer, {
        isSpaceAdmin: isSpaceAdmin,
        links: links,
        spaceId: spaceId,
        spaceKey: spaceKey,
        shortcutsHistoryRef: shortcutsHistoryRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ks2xb.EmptySidebarCollapsibleSectionLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5c93c5d8d8ceb234$var$i18n.noShortcutsMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CdLs.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle,
        testId: "page-tree-short-cuts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8INvs.ExpandableMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6lLr9))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: isSpaceAdmin && renderAddShortcutButton()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5c93c5d8d8ceb234$var$i18n.spaceShortcutsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YQCfa.ExpandableMenuItemContent), null, menuContent));
});
const $5c93c5d8d8ceb234$var$ShortcutsSectionWrapper = (0, $ggbZE.default)({
    attributes: {
        location: 'confluenceShortcuts'
    }
})((0, $7aRa9.withFlags)($5c93c5d8d8ceb234$var$ShortcutsSectionComponent));
const $5c93c5d8d8ceb234$export$7f1bcb54a9a4d80e = (props)=>{
    const initialState = window['__SSR_SHORTCUTS__'];
    const storeData = (0, $btIEy.useStoreOptions)(initialState, (0, $i6Ps3.isPageSSRd)());
    const storeOptions = (0, $i6Ps3.isPageSSRd)() ? storeData : {};
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c93c5d8d8ceb234$var$ShortcutsSectionWrapper, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $9wGTI.fg)('cfe_use_confluence_relay_env') ? (0, $9HB34.getRelayEnvironment)() : $5c93c5d8d8ceb234$var$relayEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        client: props.client,
        authFlow: "disabled",
        doNotUsePreviewPanels: true,
        ...storeOptions
    }, content)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        client: props.client,
        authFlow: "disabled",
        ...storeOptions
    }, content));
};
module.exports["ShortcutsSection"] = $5c93c5d8d8ceb234$export$7f1bcb54a9a4d80e;

});

parcelRegister("7pxpu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eWRwJ = parcelRequire("eWRwJ");

var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $sXTCx = parcelRequire("sXTCx");


var $aFv56 = parcelRequire("aFv56");


var $l4JAB = parcelRequire("l4JAB");


var $655oj = parcelRequire("655oj");


const $669d74d97f0070d8$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("bmmdJ"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $669d74d97f0070d8$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $655oj.useDatasourceClientExtension)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("bmmdJ"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $669d74d97f0070d8$export$612752b1e088a45e;
module.exports["useDatasourceLifecycleAnalytics"] = $669d74d97f0070d8$export$c82e48d9fd97c55b;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("sXTCx", function(module, exports) {
const $8b92489052cdb314$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $8b92489052cdb314$export$3f072f06b90c3985;

});

parcelRegister("aFv56", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $260a3ee885876edc$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $260a3ee885876edc$export$2e2bcd8739ae039 = $260a3ee885876edc$var$createEventPayload;
module.exports["default"] = $260a3ee885876edc$export$2e2bcd8739ae039;

});

parcelRegister("l4JAB", function(module, exports) {
/* eslint-disable compat/compat */ const $1f035c9bfd2157e4$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $1f035c9bfd2157e4$export$51d09170c61ebe04;

});

parcelRegister("655oj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9trs7 = parcelRequire("9trs7");


var $eIleF = parcelRequire("eIleF");


var $gmi3X = parcelRequire("gmi3X");


var $1Okf1 = parcelRequire("1Okf1");

const $b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE = 50;
const $b1fdc4e801245f01$export$f82fcd766a8daa7f = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$40b1dd31340bd5c2 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$15cd58682efec5a5 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$5e074c0b68e2ce03 = 20;
const $b1fdc4e801245f01$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    const resolverUrl = (0, $1Okf1.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
			 * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
			 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $gmi3X.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $gmi3X.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $b1fdc4e801245f01$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $b1fdc4e801245f01$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $42omo.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $b1fdc4e801245f01$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $42omo.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $42omo.useCallback)((ari)=>{
        $b1fdc4e801245f01$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $b1fdc4e801245f01$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $42omo.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $b1fdc4e801245f01$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $b1fdc4e801245f01$export$7d812bb756889442;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("bmmdJ", function(module, exports) {

let $8452fc4d91c8bd74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8452fc4d91c8bd74$var$load("5A9du"),
    $8452fc4d91c8bd74$var$load("6cVEd")
]).then(()=>parcelRequire('bSBwg'));

});

parcelRegister("3W9OD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7dyLS = parcelRequire("7dyLS");


var $2fkag = parcelRequire("2fkag");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $2fkag.createSearchProvider)(cloudId, (0, $7dyLS.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("2fkag", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dIeDA = parcelRequire("dIeDA");

const $f41289c0cfd3ba69$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $dIeDA.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $f41289c0cfd3ba69$export$31a7d81156fc4fa1;

});

parcelRegister("dIeDA", function(module, exports) {

var $3paC4 = parcelRequire("3paC4");

var $7dyLS = parcelRequire("7dyLS");


var $7MEO5 = parcelRequire("7MEO5");

const $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $2b54566fbe30c20f$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $7dyLS.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2b54566fbe30c20f$export$2e2bcd8739ae039;

});

parcelRegister("ks2xb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c8e6073cac605a2$export$451aa8fab889019b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3uV6b",
    name: "EmptySidebarCollapsibleSectionLoader",
    loader: async ()=>(await (parcelRequire("do2JU"))).EmptySidebarCollapsibleSectionContainerWrapper
});
module.exports["EmptySidebarCollapsibleSectionLoader"] = $0c8e6073cac605a2$export$451aa8fab889019b;

});

parcelRegister("do2JU", function(module, exports) {

let $9befa43b96ab2c03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9befa43b96ab2c03$var$load("dviIw").then(()=>parcelRequire('ieevf'));

});

parcelRegister("5ymWN", function(module, exports) {

let $40b1ed8fcb6e0018$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40b1ed8fcb6e0018$var$load("5ppK3"),
    $40b1ed8fcb6e0018$var$load("h4ycT"),
    $40b1ed8fcb6e0018$var$load("aDBL0"),
    $40b1ed8fcb6e0018$var$load("5A9du"),
    $40b1ed8fcb6e0018$var$load("e1qbZ"),
    $40b1ed8fcb6e0018$var$load("2euij"),
    $40b1ed8fcb6e0018$var$load("kZMnh"),
    $40b1ed8fcb6e0018$var$load("855o0"),
    $40b1ed8fcb6e0018$var$load("8MfZE"),
    $40b1ed8fcb6e0018$var$load("hv4mn"),
    $40b1ed8fcb6e0018$var$load("9aQIt"),
    $40b1ed8fcb6e0018$var$load("XZauT"),
    $40b1ed8fcb6e0018$var$load("4S1SF"),
    $40b1ed8fcb6e0018$var$load("lm9Lt"),
    $40b1ed8fcb6e0018$var$load("9wPDc"),
    $40b1ed8fcb6e0018$var$load("1MWOL"),
    $40b1ed8fcb6e0018$var$load("6fQco"),
    $40b1ed8fcb6e0018$var$load("aOY32"),
    $40b1ed8fcb6e0018$var$load("7jSfd"),
    $40b1ed8fcb6e0018$var$load("4HZlX"),
    $40b1ed8fcb6e0018$var$load("kDqHr"),
    $40b1ed8fcb6e0018$var$load("dYtBN"),
    $40b1ed8fcb6e0018$var$load("kNV5Y"),
    $40b1ed8fcb6e0018$var$load("6wr18"),
    $40b1ed8fcb6e0018$var$load("kjZZD"),
    $40b1ed8fcb6e0018$var$load("e6ams"),
    $40b1ed8fcb6e0018$var$load("iVgrO"),
    $40b1ed8fcb6e0018$var$load("dRpV3"),
    $40b1ed8fcb6e0018$var$load("ffEVr"),
    $40b1ed8fcb6e0018$var$load("7EorR"),
    $40b1ed8fcb6e0018$var$load("dTsOE"),
    $40b1ed8fcb6e0018$var$load("hhss7"),
    $40b1ed8fcb6e0018$var$load("aBvTF")
]).then(()=>parcelRequire('2Sqmi'));

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("9sGCn", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataContentFragment on Content{id subType status}`
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataSubTypeContentFragment on Content{id subType}`
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataSubTypePageTreeFragment on PTPage{id subType}`
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $eSUdr.default)`fragment getCachedPageDataSubTypeSearchFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/editor-features/src/utils/getCachedPageTitle.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("6GQtz", function(module, exports) {

var $477dG = parcelRequire("477dG");

class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $477dG.EditorCardProvider) {
    // TODO: Override for Confluence-specific defaults (still call super for base class fallback)
    // 	https://hello.jira.atlassian.cloud/browse/CCINT-7186
    getHardCodedAppearance(url) {
        return super.getHardCodedAppearance(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient);
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("g2a13", function(module, exports) {
/**
 * @generated SignedSource<<40a9b1b35e96896444397cd77791fa4d>>
 * @relayHash fe506bd9046797cde11ab0f7fcc9d885
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be
const $53f7ad90e8632c3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "position"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe506bd9046797cde11ab0f7fcc9d885",
            "id": "854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be",
            "metadata": {},
            "name": "useShortcutsSpaceNavigationQuery",
            "operationKind": "query",
            "text": "query useShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){__typename,quick{id,url,position,title,styleClass}}}"
        }
    };
}();
$53f7ad90e8632c3f$var$node.hash = "52dba71769af710a3e1e472bed635436";
var $53f7ad90e8632c3f$export$2e2bcd8739ae039 = $53f7ad90e8632c3f$var$node;
module.exports["default"] = $53f7ad90e8632c3f$export$2e2bcd8739ae039;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/available-sites` : '/gateway/api/available-sites', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/v2/accessible-products` : '/gateway/api/v2/accessible-products', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::6aeaf735bb1855a8d29ca67bd7a680b4>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const event = eventKey.split('.');
    return {
        eventType: event[0],
        actionSubject: event[1],
        action: event[2],
        actionSubjectId: event[3],
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("9ImuD", function(module, exports) {

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("5Ndvb"));
        case 'da-DK':
            return (parcelRequire("iiIXH"));
        case 'de-DE':
            return (parcelRequire("2Tsxu"));
        case 'en-US':
            return (parcelRequire("kcHy2"));
        case 'en-GB':
            return (parcelRequire("itcXa"));
        case 'en-ZZ':
            return (parcelRequire("gchso"));
        case 'es-ES':
            return (parcelRequire("96L2T"));
        case 'fi-FI':
            return (parcelRequire("jaVup"));
        case 'fr-FR':
            return (parcelRequire("97KoO"));
        case 'hu-HU':
            return (parcelRequire("8lubX"));
        case 'it-IT':
            return (parcelRequire("eNKAp"));
        case 'ja-JP':
            return (parcelRequire("eVHt2"));
        case 'ko-KR':
            return (parcelRequire("9l54B"));
        case 'no-NO':
            return (parcelRequire("9lkMC"));
        case 'nl-NL':
            return (parcelRequire("7m1Mp"));
        case 'pl-PL':
            return (parcelRequire("fGUyM"));
        case 'pt-BR':
            return (parcelRequire("4jTFc"));
        case 'ru-RU':
            return (parcelRequire("aHFLL"));
        case 'sv-SE':
            return (parcelRequire("iNU9J"));
        case 'tr-TR':
            return (parcelRequire("iHxcT"));
        case 'th-TH':
            return (parcelRequire("bhuCG"));
        case 'uk-UA':
            return (parcelRequire("lLUi2"));
        case 'vi-VN':
            return (parcelRequire("fL5hj"));
        case 'zh-TW':
            return (parcelRequire("fpOoD"));
        case 'zh-CN':
            return (parcelRequire("ag1zA"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;
module.exports["default"] = $efd7e121efbbc6f0$export$2e2bcd8739ae039;

});

parcelRegister("5Ndvb", function(module, exports) {

let $437c00935acb14ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $437c00935acb14ea$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("iiIXH", function(module, exports) {

let $d52cc8f43585e630$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d52cc8f43585e630$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("2Tsxu", function(module, exports) {

let $21b6db1ee7e67ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b6db1ee7e67ba5$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("kcHy2", function(module, exports) {

let $eb56b55f48170862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb56b55f48170862$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("itcXa", function(module, exports) {

let $d724fbaf6f612dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d724fbaf6f612dc2$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("gchso", function(module, exports) {

let $bcab4eeeab7106ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcab4eeeab7106ed$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("96L2T", function(module, exports) {

let $6a192ae0f9ce7ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a192ae0f9ce7ae7$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("jaVup", function(module, exports) {

let $df5b8bb747e71066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5b8bb747e71066$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("97KoO", function(module, exports) {

let $6a48c2662010f84a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a48c2662010f84a$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("8lubX", function(module, exports) {

let $6137b461e0c0d233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6137b461e0c0d233$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("eNKAp", function(module, exports) {

let $ac69c757ef6ed44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac69c757ef6ed44a$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("eVHt2", function(module, exports) {

let $ade81b488ae26811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ade81b488ae26811$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9l54B", function(module, exports) {

let $6cca02a75f916cfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cca02a75f916cfb$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("9lkMC", function(module, exports) {

let $6cd63251145b2739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cd63251145b2739$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("7m1Mp", function(module, exports) {

let $55abf7e453b9933f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55abf7e453b9933f$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("fGUyM", function(module, exports) {

let $b6c6a6ea694df539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6c6a6ea694df539$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("4jTFc", function(module, exports) {

let $32541d63110b786f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32541d63110b786f$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("aHFLL", function(module, exports) {

let $7cae5214955aa781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cae5214955aa781$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("iNU9J", function(module, exports) {

let $db085cfb205ba45c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db085cfb205ba45c$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("iHxcT", function(module, exports) {

let $d9d6005709d91a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9d6005709d91a65$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("bhuCG", function(module, exports) {

let $8369094a4603e1c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8369094a4603e1c8$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("lLUi2", function(module, exports) {

let $fd99a6c46b5179db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd99a6c46b5179db$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("fL5hj", function(module, exports) {

let $b78f56f44c93f165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b78f56f44c93f165$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("fpOoD", function(module, exports) {

let $b39048758b7c76b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39048758b7c76b0$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("ag1zA", function(module, exports) {

let $777c9e58e5d8ad11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777c9e58e5d8ad11$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});

parcelRegister("dj7jL", function(module, exports) {
const $e6073c916b049162$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    JIRA: 'jira'
};
module.exports["PARENT_PRODUCTS"] = $e6073c916b049162$export$bc4191f7b8dfa3a4;

});

parcelRegister("1DfVr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $io4wE = parcelRequire("io4wE");

const $af9c2f3d9e69f02f$export$46eb6ca3d43ca839 = (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $42omo.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $io4wE.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $42omo.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $af9c2f3d9e69f02f$export$46eb6ca3d43ca839;

});

parcelRegister("io4wE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $c6GJD = parcelRequire("c6GJD");


var $8jHAi = parcelRequire("8jHAi");


var $cOrQJ = parcelRequire("cOrQJ");


var $bHGk9 = parcelRequire("bHGk9");


var $ibFXh = parcelRequire("ibFXh");

var $1GJJf = parcelRequire("1GJJf");

var $aSy6D = parcelRequire("aSy6D");

var $8APLM = parcelRequire("8APLM");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");


var $4BDAe = parcelRequire("4BDAe");


var $cu1WV = parcelRequire("cu1WV");


var $aXOz9 = parcelRequire("aXOz9");

const $178f91e075c3dc2a$var$styles = {
    body: "_16jlkb7n _18m915vq _ca0q1ejb _u5f31ejb _19bv1ejb"
};
const $178f91e075c3dc2a$export$a8a96573251792b1 = ({ url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const themeState = (0, $cOrQJ.default)();
    const { actions: actions } = panelData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setAnalyticsClient((0, $aXOz9.initializeAnalyticsClient)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $aXOz9.onEditMode)(mode, setPanelWidth);
    const onClose = ()=>{
        actions?.onClose?.();
        close();
    };
    const formattedUrl = (0, $42omo.useMemo)(()=>(0, $aXOz9.constructUrl)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    const embeddedConfluenceSource = (()=>{
        try {
            const urlObj = new URL(formattedUrl);
            return urlObj.searchParams.get('embeddedConfluenceSource');
        } catch  {
            return null;
        }
    })();
    const isProjectPagesUxRevampExpEnabled = (0, $c6GJD.default).getExperimentValue('project-pages-ux-revamp-experiment', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const runtimeProps = {
        url: formattedUrl,
        showFooter: false,
        hasFooterLogo: false,
        onModeChange: onModeChange,
        parentProduct: parentProduct,
        embeddedConfluenceSource: embeddedConfluenceSource && isProjectPagesUxRevampExpEnabled ? embeddedConfluenceSource : 'confluence-page-preview-panel',
        themeState: themeState
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        testId: "confluence-preview-panel",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3ZVni.PreviewPanelHeader), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                onClose: onClose,
                onOpenInNewTab: actions?.onOpenInNewTab,
                url: formattedUrl,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                        title: formatMessage((0, $cu1WV.messages).pageTitle),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    !!actions && /*#__PURE__*/ (0, $l998X.jsx)((0, $1GJJf.PreviewPanelActionGroup), {
                        children: actions.onExpand && /*#__PURE__*/ (0, $l998X.jsx)((0, $8APLM.PreviewPanelExpand), {
                            onClick: actions.onExpand
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                styles: $178f91e075c3dc2a$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bHGk9.EmbeddedConfluence), {
                    ...runtimeProps
                })
            })
        ]
    });
};
const $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent = ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData } })=>/*#__PURE__*/ (0, $l998X.jsx)($178f91e075c3dc2a$export$a8a96573251792b1, {
        url: url,
        parentProduct: parentProduct,
        cloudId: cloudId,
        panelData: panelData
    });
var $178f91e075c3dc2a$export$2e2bcd8739ae039 = $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent;
module.exports["ConfluencePagePreviewPanel"] = $178f91e075c3dc2a$export$a8a96573251792b1;
module.exports["default"] = $178f91e075c3dc2a$export$2e2bcd8739ae039;

});

parcelRegister("bHGk9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $aqrhZ = parcelRequire("aqrhZ");


var $kFwgS = parcelRequire("kFwgS");

var $I1nNR = parcelRequire("I1nNR");

var $kudeD = parcelRequire("kudeD");


var $9ImuD = parcelRequire("9ImuD");

const $4a221c0892a490b0$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
}; // @ts-ignore

const $4a221c0892a490b0$var$LazyEmbeddedConfluence = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("jTnr1")));
const $4a221c0892a490b0$export$c4789cfd0b0cd2c4 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kudeD.PerformanceMetricsProvider), {
            contentType: props.mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
            sourceComponent: 'EmbeddedConfluence',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4a221c0892a490b0$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($4a221c0892a490b0$var$LazyEmbeddedConfluence, {
                    ...props
                })
            })
        })
    });
module.exports["EmbeddedConfluence"] = $4a221c0892a490b0$export$c4789cfd0b0cd2c4;

});

parcelRegister("jTnr1", function(module, exports) {

let $e7b5550e4add958f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e7b5550e4add958f$var$load("2euij"),
    $e7b5550e4add958f$var$load("kZMnh"),
    $e7b5550e4add958f$var$load("Wowvf"),
    $e7b5550e4add958f$var$load("hhss7"),
    $e7b5550e4add958f$var$load("kG8pF")
]).then(()=>parcelRequire('9bXIX'));

});

parcelRegister("1GJJf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

const $1fc8fb56653d2345$export$b3bbf50939c515ce = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        space: "space.050",
        alignBlock: "center",
        children: children
    });
};
module.exports["PreviewPanelActionGroup"] = $1fc8fb56653d2345$export$b3bbf50939c515ce;

});

parcelRegister("8APLM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lOzEN = parcelRequire("lOzEN");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $91e6116a3cc9352a$export$40b251582cb3e1fe = ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelExpand"] = $91e6116a3cc9352a$export$40b251582cb3e1fe;

});

parcelRegister("cu1WV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11543dd8ad4b06d3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});
module.exports["messages"] = $11543dd8ad4b06d3$export$defe85febe8b728c;

});

parcelRegister("aXOz9", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kFwgS = parcelRequire("kFwgS");

var $3WsBD = parcelRequire("3WsBD");

const $8f94b4972688fbbf$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $8f94b4972688fbbf$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $8f94b4972688fbbf$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $8f94b4972688fbbf$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $a9sR2.default)({
        product: 'confluencePreviewPanel',
        env: $8f94b4972688fbbf$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $8f94b4972688fbbf$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $8f94b4972688fbbf$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $3WsBD.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $8f94b4972688fbbf$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $8f94b4972688fbbf$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};
module.exports["onEditMode"] = $8f94b4972688fbbf$export$232fd46a0431e57a;
module.exports["initializeAnalyticsClient"] = $8f94b4972688fbbf$export$7d842b959fcdcd03;
module.exports["constructUrl"] = $8f94b4972688fbbf$export$a639a54e55b70225;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});


//# sourceMappingURL=ShortcutsSection.38605390.js.map
